import SurveySeriesEditComponent from '../../components/SurveySeries/SurveySeriesEdit';

function SurveySeriesEdit() {
  return <SurveySeriesEditComponent />;
}

export default SurveySeriesEdit;
